import axios from 'axios';

// In production (Docker), frontend is served by the same Express server,
// so relative '/api' works. In local dev, CRA proxy (see package.json
// "proxy" field is not used here - we set baseURL explicitly instead).
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

// IMPORTANT: we use sessionStorage (not localStorage) for the auth token.
// localStorage is shared across every tab of the same browser, which meant
// a doctor logged in on one tab and a receptionist logging in on another
// tab of the SAME browser would silently overwrite each other's session.
// sessionStorage is scoped to a single tab, so the doctor and receptionist
// can be logged in at the same time in two tabs of the same browser (or of
// course on two different devices) without interfering with each other.
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('dq_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      sessionStorage.removeItem('dq_token');
      sessionStorage.removeItem('dq_user');
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
